import { CardLink } from '@veneer/core';
import tokens from '@veneer/tokens';
import styled from 'styled-components';
import { MastiffOfferButton } from 'src/components/MastiffOfferTag/styles';

export const CardSection = styled(CardLink)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.layout.size2};
  border-radius: ${tokens.layout.cornerRadius3};
  outline: none;
  transition: none;

  && {
    padding: ${tokens.layout.size4};
    border-radius: ${tokens.layout.size4};
  }

  @media screen and (max-width: ${tokens.layout.smMin}) {
    width: stretch;
  }

  /* Cancel card hover effect when hovering the offer tag */
  &&:hover:has(${MastiffOfferButton}:hover) {
    border-color: #e0e0e0;
  }

  &:focus-visible {
    position: relative;
    border-color: transparent !important;
    outline: #001cb0 solid 2px !important;
    outline-offset: 0 !important;
  }
`;

export const DeviceImage = styled.div`
  display: flex;
  align-self: center;
  height: 220px;
  padding: 0 20px 0 20px;

  & > svg,
  img {
    cursor: pointer;
    width: 292.67px;
    height: 220px;

    @media screen and (max-width: ${tokens.layout.smMin}) {
      width: 100%;
      height: 160px;
    }
  }

  @media screen and (max-width: ${tokens.layout.smMin}) {
    height: 160px;
  }
`;

export const ContentType = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${tokens.layout.size2};
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size1};
`;

const BaseText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 320px;

  @media screen and (max-width: ${tokens.layout.smMin}) {
    width: 200px;
  }
`;

export const DeviceName = styled(BaseText)`
  color: ${tokens.color.gray9};
`;

export const DeviceInfo = styled(BaseText)`
  color: ${tokens.color.gray6};
`;

export const OfferTag = styled.div`
  min-height: ${tokens.layout.size8};
  max-height: ${tokens.layout.size8};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${tokens.layout.size2};
`;
